import { FC } from 'react';

import { isAndroid } from '../../../../helpers/Device';
import AndroidPhotoPicker from './AndroidPhotoPicker';
import DefaultPhotoPicker from './DefaultPhotoPicker';
import { PhotoPickerProps } from './usePhotoPicker';

const PhotoPicker: FC<PhotoPickerProps> = (props) => {
  if (isAndroid()) return <AndroidPhotoPicker {...props} />;

  return <DefaultPhotoPicker {...props} />;
};

export default PhotoPicker;
